// extracted by mini-css-extract-plugin
export default {"sweepTableFilterTablet":"sweeps_sweepTableFilterTablet__M2FFP"};